import { TTopicPathList } from '../type/Type';

/** パターン */
export const topicPathList: TTopicPathList = {
  // ダッシュボード
  dashboard: [{ url: '', name: 'ダッシュボード' }],
  // 目標設定
  sales_setting: [
    { url: '/dashboard', name: 'ダッシュボード' },
    { url: '', name: '目標設定' }
  ],

  // 工事一覧
  constructions: [{ url: '', name: '工事' }],
  // 工事一覧から新規作成
  constructions_create: [
    { url: '/constructions', name: '工事' },
    { url: '', name: '工事作成' }
  ],
  // 工事一覧から工事を選択
  constructions_edit: [
    { url: '/constructions', name: '工事' },
    { url: '', name: '工事詳細' }
  ],
  // 工事一覧 > 工事詳細 > 契約書フォーマットダウンロード
  contracts_format: [
    { url: '/constructions', name: '工事' },
    { url: 'goBack', name: '工事詳細' },
    { url: '', name: '契約書フォーマットダウンロード' }
  ],

  // 書類管理（選択すると初期画面は見積書）
  estimates: [{ url: '', name: '作成済書類' }],
  // 書類管理、見積書新規作成
  estimates_create: [
    { url: '/estimates', name: '作成済書類' },
    { url: '', name: '見積書作成' }
  ],
  // 書類管理、作成された見積書選択
  estimates_edit: [
    { url: '/estimates', name: '作成済書類' },
    { url: '', name: '見積書編集' }
  ],

  // 書類管理、請求書(タブ）を選択
  invoices: [{ url: '', name: '作成済書類' }],
  // 書類管理、請求書を新規作成
  invoices_create: [
    { url: '/invoices', name: '作成済書類' },
    { url: '', name: '請求書作成' }
  ],
  // 書類管理、作成された請求書を選択
  invoices_edit: [
    { url: '/invoices', name: '作成済書類' },
    { url: '', name: '請求書編集' }
  ],

  // 書類管理、契約書(タブ）を選択
  contracts: [{ url: '', name: '作成済書類' }],
  // 書類管理、契約書を新規作成
  contracts_create: [
    { url: '/contracts', name: '作成済書類' },
    { url: '', name: '契約書作成' }
  ],
  // 書類管理、作成された契約書を選択
  contracts_edit: [
    { url: '/contracts', name: '作成済書類' },
    { url: '', name: '契約書編集' }
  ],

  // 書類管理、商品発注書（タブ）を選択
  merchandise_orders: [{ url: '', name: '作成済書類' }],
  // 書類管理、商品発注書を新規作成
  merchandise_orders_create: [
    { url: '/merchandise-orders', name: '作成済書類' },
    { url: '', name: '商品発注書作成' }
  ],
  // 書類管理、作成された商品発注書を選択
  merchandise_orders_edit: [
    { url: '/merchandise-orders', name: '作成済書類' },
    { url: '', name: '商品発注書編集' }
  ],

  // 書類管理、外注発注書（タブ）を選択
  outsource_orders: [{ url: '', name: '作成済書類' }],
  // 書類管理、外注発注書を新規作成
  outsource_orders_create: [
    { url: '/outsource-orders', name: '作成済書類' },
    { url: '', name: '外注発注書作成' }
  ],
  // 書類管理、作成された外注発注書
  outsource_orders_edit: [
    { url: '/outsource-orders', name: '作成済書類' },
    { url: '', name: '外注発注書編集' }
  ],

  // 書類管理、現場連絡表（タブ）を選択
  site_contacts: [{ url: '', name: '作成済書類' }],
  // 書類管理、現場連絡表を新規作成
  site_contacts_create: [
    { url: '/site-contacts', name: '作成済書類' },
    { url: '', name: '現場連絡表作成' }
  ],
  // 書類管理、作成された現場連絡表
  site_contacts_edit: [
    { url: '/site-contacts', name: '作成済書類' },
    { url: '', name: '現場連絡表編集' }
  ],
  // 書類管理、作成された見積書を選択
  working_budget_edit: [
    { url: '/working-budgets', name: '作成済書類' },
    { url: '', name: '実行予算表編集' }
  ],

  // PDFダウンロード
  pdf_download: [{ url: '', name: 'PDFダウンロード' }],
  // 見積書マスタ
  estimate_master: [{ url: '', name: '見積書マスタ' }],
  // 見積書マスタ、新規作成
  estimate_master_create: [
    { url: '/estimate-master', name: '見積書マスタ' },
    { url: '', name: '見積書マスタ作成' }
  ],
  // 作成された見積書マスタを選択
  estimate_master_edit: [
    { url: '/estimate-master', name: '見積書マスタ' },
    { url: '', name: '見積書マスタ編集' }
  ],

  // 顧客一覧
  customers: [{ url: '', name: '顧客' }],
  // 顧客一覧、新規作成
  customers_create: [
    { url: '/customers', name: '顧客' },
    { url: '', name: '顧客作成' }
  ],
  // 顧客一覧、作成された顧客を選択
  customers_edit: [
    { url: '/customers', name: '顧客' },
    { url: '', name: '顧客詳細' }
  ],
  // 顧客種別マスタ
  customertypes: [{ url: '', name: '顧客種別マスタ' }],
  // 案件種別マスタ
  construct_types: [{ url: '', name: '案件種別マスタ' }],
  // 業者一覧
  vendors: [{ url: '', name: '業者' }],
  // 業者一覧、新規作成
  vendors_create: [
    { url: '/vendors', name: '業者' },
    { url: '', name: '業者作成' }
  ],
  // 業者一覧、作成された業者を選択
  vendors_edit: [
    { url: '/vendors', name: '業者' },
    { url: '', name: '業者詳細' }
  ],
  // 業種マスタ
  partner_categories: [{ url: '', name: '業種マスタ' }],
  // 単位マスタ
  unit_master: [{ url: '', name: '単位マスタ' }],
  // 受取書類管理（選択すると初期画面は見積書）
  receipt_estimates: [{ url: '', name: '受取書類' }],
  // 受取書類管理、見積書詳細から新規外注発注書作成
  receipt_estimates_create: [
    { url: '/received/estimates', name: '受取書類' },
    { url: '', name: '外注発注書作成' }
  ],

  // 受取書類管理、外注発注書（タブ）を選択
  estimates_invoice: [{ url: '', name: '受取書類' }],
  // 受取書類管理、外注発注書詳細から新規請求書作成
  estimates_invoice_create: [
    { url: '/received/outsource-orders', name: '受取書類' },
    { url: '', name: '請求書作成' }
  ],

  // 資料一覧
  files: [{ url: '', name: '資料' }],

  // 写真一覧
  pictures: [{ url: '', name: '写真' }],

  // 共有先一覧
  guest_manage: [{ url: '', name: '共有先管理' }],

  // 資料操作履歴
  filelog: [{ url: '', name: '操作履歴' }],

  // 社員マスタ
  employee_masters: [{ url: '', name: '社員' }],
  // 社員マスタ、新規作成
  employee_masters_create: [
    { url: '/employee-masters', name: '社員' },
    { url: '', name: '社員作成' }
  ],
  // 社外パートナー、新規作成
  outside_partnerem_create: [
    { url: '/employee-masters', name: '社員' },
    { url: '', name: '社外パートナー作成' }
  ],
  // 社員マスタ、作成された社員を選択
  employee_masters_edit: [
    { url: '/employee-masters', name: '社員' },
    { url: '', name: '社員詳細' }
  ],
  // 社外パートナー、作成された社外パートナーを選択
  outside_partnerem_edit: [
    { url: '/employee-masters', name: '社員' },
    { url: '', name: '社外パートナー詳細' }
  ],

  // 社員グループ
  employee_groups: [{ url: '', name: '社員グループ' }],
  // 社員グループ、新規作成
  employee_groups_create: [
    { url: '/employee-groups', name: '社員グループ' },
    { url: '', name: '社員グループ作成' }
  ],
  // 社員グループ、作成されたグループ
  employee_groups_edit: [
    { url: '/employee-groups', name: '社員グループ' },
    { url: '', name: '社員グループ編集' }
  ],

  // 工程表
  site_processes: [{ url: '', name: '工程' }],
  // タスク管理
  site_tasks: [
    { url: '/processes', name: '工程' },
    { url: '', name: 'タスク管理' }
  ],
  // 日報
  daily_reports: [{ url: '', name: '日報' }],
  calendar: [{ url: '', name: 'カレンダー' }],

  // 出面管理
  attendance: [{ url: '', name: '出面管理' }],
  // 出面管理
  attendance_dashboard: [{ url: '', name: '出面管理ダッシュボード' }],

  // 企業情報
  company_information: [{ url: '', name: '自社情報' }],

  // パスワード変更
  change_password: [{ url: '', name: 'パスワード変更' }],

  // 写真台帳一覧
  ledger_list: [{ url: '/ledger-list', name: '写真台帳一覧' }],
  // 写真台帳編集
  edit_ledger: [
    { url: '/ledger-list', name: '写真台帳一覧' },
    { url: '', name: '写真台帳編集' }
  ],
  // 写真台帳作成
  create_ledger: [
    { url: '/ledger-list', name: '写真台帳一覧' },
    { url: '', name: '写真台帳作成' }
  ],

  // 写真台帳作成(写真から)
  create_ledger_pictures: [
    { url: '/pictures', name: '写真' },
    { url: '', name: '写真台帳作成' }
  ],

  // 資料種別一覧
  filetypes: [{ url: '', name: '資料種別' }],

  // メール送信履歴
  mailsendlog: [{ url: '', name: 'メール送信履歴' }],
  // 実行予算
  working_budget: [{ url: '', name: '実行予算' }],
  working_budgets: []
};
